import { format, formatDistanceToNow } from "date-fns";
import dayjs from "dayjs";

export const fToNow = (date) =>
  formatDistanceToNow(new Date(date), { addSuffix: true });

export const convertDateToYYYYMMDD = (arr) => {
  if (!Array.isArray(arr)) {
    console.error("Invalid data passed to convertDateToYYYYMMDD :", arr);
    return [];
  }
  return arr.map(({ date, hours }) => {
    const parsedDate = new Date(date);
    const formattedDate = `${parsedDate.getFullYear()}-${String(
      parsedDate.getMonth() + 1
    ).padStart(2, "0")}-${String(parsedDate.getDate()).padStart(2, "0")}`;

    return { date: formattedDate, hours };
  });
};

export const NumberTypeChecker = (dataToCheck) => {
  if (Array.isArray(dataToCheck)) {
    return dataToCheck.length;
  }
  return typeof dataToCheck === "number" ? dataToCheck : NaN;
};

export const formatDate = (date) => {
  return date ? dayjs(date).format("YYYY-MM-DD") : "";
};

export const fDateMDY = (date) => {
  try {
    if (!date) return "";
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return "";
    return format(parsedDate, "yyyy-MM-dd");
  } catch (error) {
    console.error("fDateMDY: Date formatting error:", error.message);
    return "";
  }
};
